import React from 'react';
import StatusBar from './StatusBar';

/**
 * PhoneFrame component that wraps content in a mobile phone frame
 * Enhanced with modern styling and smoother edges
 */
const PhoneFrame = ({ children, className = "" }) => {
  return (
    <div className={`flex items-center justify-center py-8 px-4 ${className}`}>
      <div 
        className="phone-frame rounded-[40px] border-[12px] border-gray-800 bg-white relative overflow-hidden"
        style={{
          width: '280px',
          height: '580px',
          boxShadow: '0 30px 60px rgba(0,0,0,0.12), inset 0 -2px 6px 0 rgba(10,10,10,0.06)'
        }}
      >
        {/* Phone notch */}
        <div 
          className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[120px] h-[28px] bg-gray-800 z-20"
          style={{
            borderBottomLeftRadius: '14px',
            borderBottomRightRadius: '14px'
          }}
        >
          <div className="w-8 h-2 bg-gray-900 rounded-full absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></div>
        </div>
        
        {/* Phone status bar */}
        <StatusBar />
        
        {/* Phone content */}
        <div 
          className="relative h-full overflow-hidden pt-7 bg-gray-50"
          style={{
            borderRadius: '28px'
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PhoneFrame; 